import React from 'react';
import { Modal, message, Spin, Select, Checkbox, Radio, Input, Upload, Button, InputNumber, Table } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import { xToken } from '../../../../common/AjaxRequest';
import ExportUtil from '../../../../common/ExportUtil';
import format from '../../../shared/format';

const Option = Select.Option;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const Config = {
    openFinance: {
        title: '申请开启财务数据调整',
        url: API_URL.contract.startInvFinancialAdjust,
    },
    approvalFinance: {
        title: '审批财务数据调整',
        url: API_URL.contract.approveInvFinancialAdjust,
    },
    reOpenFinance: {
        title: '申请开启财务数据调整',
        url: API_URL.contract.restartInvFinancialAdjust,
    },
    view: {
        title: '财务数据调整详情',
    }
}

class FinanceAdjust extends React.Component {
    state = {
        loading: false,
        visible: false,
        record: {},
        params: {},
        fileList: [],
        customerCompanyList: [],
        investigationJdeContractList: [],
        type: 'openFinance',
    }

    show = (record = {}, type) => {
        const { investigationId } = record;
        this.setState({
            visible: true,
            record: { ...record },
            type,
        }, () => {
            switch (type) {
                case 'openFinance':
                    this.queryCustomerCompany(investigationId);
                    break;
                case 'approvalFinance':
                case 'view':
                    this.queryInvFinancialAdjustDetail(investigationId);
                    break;
                case 'reOpenFinance':
                    this.queryCustomerCompany(investigationId);
                    this.queryInvFinancialAdjustDetail(investigationId);
                    break;
            }
        });
    }

    //获取最新财务数据调整
    queryInvFinancialAdjustDetail = (invId) => {
        const options = {
            method: 'POST',
            url: API_URL.contract.queryInvFinancialAdjustDetail,
            data: {
                invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { investigationFinancialAdjust } = res;
                const { applyType, costType, customerConfirmFlag, customerCompanyId, ossFileList } = investigationFinancialAdjust;
                this.queryCustomerCompanyJde(customerCompanyId);
                (ossFileList || []).forEach(el => {
                    el.response = { id: el.id };
                    el.uid = el.id;
                    el.name = el.fileName;
                });
                this.setState({
                    params: {
                        ...investigationFinancialAdjust,
                        applyType: (applyType || '').split(','),
                        costType: (costType || '').split(','),
                        customerConfirmFlagShow: customerConfirmFlag === 'YES' ? '有': customerConfirmFlag === 'NO' ? '无' : '',
                    },
                    fileList: [ ...ossFileList ],
                });
            }
        };
        $.sendRequest(options);
    }

    //获取客户名称
    queryCustomerCompany = (invId) => {
        const options = {
            method: 'POST',
            url: API_URL.contract.queryCustomerCompany,
            data: {
                invId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ customerCompanyList: res.customerCompanyList });
            }
        };
        $.sendRequest(options);
    }

    //获取JDE项目号
    queryCustomerCompanyJde = (customerCompanyId) => {
        const { record: { investigationId } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.contract.queryCustomerCompanyJde,
            data: {
                invId: investigationId,
                customerCompanyId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ investigationJdeContractList: res.investigationJdeContractList });
            }
        };
        $.sendRequest(options);
    }

    //获取已开票金额和CTMS登记签署金额
    queryInvoicedAmountAndSignAmount = (customerCompanyId, investigationJdeContractCode, costType = []) => {
        if (!customerCompanyId || !investigationJdeContractCode || !costType[0]) {
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.contract.queryInvoicedAmountAndSignAmount,
            data: {
                customerCompanyId,
                jdeCode: investigationJdeContractCode,
                costType: costType.join(','),
            },
            dataType: 'json',
            doneResult: res => {
                const { params } = this.state;
                const { serviceInvoicedAmount, serviceCtmsSignAmount, ptInvoicedAmount, ptCtmsSignAmount } = res.investigationFinancialAdjust;
                params.serviceInvoicedAmount = serviceInvoicedAmount;
                params.serviceCtmsSignAmount = serviceCtmsSignAmount;
                params.ptInvoicedAmount = ptInvoicedAmount;
                params.ptCtmsSignAmount = ptCtmsSignAmount;
                this.setState({ params },() => {
                    this.queryShouldAdjustAmountAndEstimateIncomeAmount();
                });
            }
        };
        $.sendRequest(options);
    }

    //获取本次应调整金额和预估收入影响金额
    queryShouldAdjustAmountAndEstimateIncomeAmount = () => {
        const { params, record: { investigationId } } = this.state;
        const {
            costType = [],
            serviceCtmsSignAmount,
            ptCtmsSignAmount,
            investigationJdeContractCode,
            serviceActualTotalAmount,
            ptActualTotalAmount,
        } = params;
        //判断某个或某些数值是否存在
        const estimate = (data = []) => {
            return data.every(el => el || el === 0)
        }

        if (costType.length === 0) {
            return
        } else if (costType.length === 1) {
            switch (costType[0]) {
                case 'SERVICE_COST':
                    if (!estimate([serviceCtmsSignAmount, serviceActualTotalAmount])) {
                        return
                    }
                    break;
                case 'PT_COST':
                    if (!estimate([ptCtmsSignAmount, ptActualTotalAmount])) {
                        return
                    }
                    break;
            }
        } else if (costType.length === 2) {
            if (!estimate([serviceCtmsSignAmount, serviceActualTotalAmount, ptCtmsSignAmount, ptActualTotalAmount])) {
                return
            }
        }
        const sendParams = {
            invId: investigationId,
            costType: costType.join(','),
            jdeCode: investigationJdeContractCode,
            serviceCtmsSignAmount,
            serviceActualTotalAmount,
            ptCtmsSignAmount,
            ptActualTotalAmount,
        };
        const options = {
            method: 'POST',
            url: API_URL.contract.queryShouldAdjustAmountAndEstimateIncomeAmount,
            data: {
                ...sendParams
            },
            dataType: 'json',
            doneResult: res => {
                const { params } = this.state;
                const { shouldAdjustAmount, estimateIncomeAmount, costIncrDecr } = res.investigationFinancialAdjust;
                params.shouldAdjustAmount = shouldAdjustAmount;
                params.estimateIncomeAmount = estimateIncomeAmount;
                params.costIncrDecr = costIncrDecr;
                this.setState({ params });
            }
        };
        $.sendRequest(options);
    }


    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            record: {},
            params: {},
            fileList: [],
        });
    }

    submit = () => {
        const { params, fileList = [], record: { investigationId, investigationName }, type } = this.state;
        const {
            id,
            applyType = [],
            customerCompanyId,
            customerConfirmFlag,
            investigationJdeContractCode,
            costType = [],
            serviceInvoicedAmount,
            serviceExpectedPaymentAmount,
            serviceSubsequentPaymentAmount,
            serviceActualTotalAmount,
            serviceCtmsSignAmount,
            ptInvoicedAmount,
            ptExpectedPaymentAmount,
            ptSubsequentPaymentAmount,
            ptActualTotalAmount,
            ptCtmsSignAmount,
            shouldAdjustAmount,
            estimateIncomeAmount,
            costIncrDecr,
            adjustDesc,
            approvalStatus,
            reason,
        } = params;
        if (type === 'approvalFinance') {
            if (!approvalStatus) {
                return message.warning('请选择审批结论');
            }
            if (approvalStatus === 'APPROVE_NOT_PASS' && !reason) {
                return message.warning('请输入不通过原因');
            }
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.contract.approveInvFinancialAdjust,
                data: {
                    id,
                    approvalStatus,
                    reason,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.props.loadData();
                }
            };
            $.sendRequest(options);
        }
        if (type === 'openFinance' || type === 'reOpenFinance') {
            //校验必填
            if (!applyType[0]) {
                return message.warning('请选择申请类型');
            }
            if (!customerCompanyId) {
                return message.warning('请选择客户名称');
            }
            if (!customerConfirmFlag) {
                return message.warning('请选择有无客户确认资料');
            }
            if (customerConfirmFlag === 'YES' && fileList.length === 0) {
                return message.warning('请选择需要上传的附件');
            }
            if (!investigationJdeContractCode) {
                return message.warning('请选择JDE项目号');
            }
            if (!costType[0]) {
                return message.warning('请选择申请开票费用类型');
            }
            if (estimateIncomeAmount !== 0 && !estimateIncomeAmount) {
                return message.warning('请输入预估收入影响金额（仅影响审批流）');
            }
            const showService = costType.length === 2 ? true : costType[0] === 'SERVICE_COST';
            const showPt = costType.length === 2 ? true : costType[0] === 'PT_COST';
            const fromData = new FormData();
            fileList.map((file, index) => {
                fromData.append(`files[${index}]`, file)
            });
            if (type === 'reOpenFinance') fromData.append('id', id);
            fromData.append('invId', investigationId);
            fromData.append('invName', investigationName);
            fromData.append('curUserId', sessionStorage.userId);
            fromData.append('curRoleCode', sessionStorage.curRole);
            fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');
            fromData.append('applyType', applyType.join(','));
            fromData.append('customerCompanyId', customerCompanyId);
            fromData.append('customerConfirmFlag', customerConfirmFlag);
            fromData.append('investigationJdeContractCode', investigationJdeContractCode);
            fromData.append('costType', costType.join(','));
            if (showService) fromData.append('serviceInvoicedAmount', serviceInvoicedAmount);
            if (showService) fromData.append('serviceExpectedPaymentAmount', serviceExpectedPaymentAmount);
            if (showService) fromData.append('serviceSubsequentPaymentAmount', serviceSubsequentPaymentAmount);
            if (showService) fromData.append('serviceActualTotalAmount', serviceActualTotalAmount);
            if (showService) fromData.append('serviceCtmsSignAmount', serviceCtmsSignAmount);
            if (showPt) fromData.append('ptInvoicedAmount', ptInvoicedAmount);
            if (showPt) fromData.append('ptExpectedPaymentAmount', ptExpectedPaymentAmount);
            if (showPt) fromData.append('ptSubsequentPaymentAmount', ptSubsequentPaymentAmount);
            if (showPt) fromData.append('ptActualTotalAmount', ptActualTotalAmount);
            if (showPt) fromData.append('ptCtmsSignAmount', ptCtmsSignAmount);
            fromData.append('shouldAdjustAmount', shouldAdjustAmount);
            fromData.append('estimateIncomeAmount', estimateIncomeAmount);
            fromData.append('costIncrDecr', costIncrDecr);
            if (adjustDesc) fromData.append('adjustDesc', adjustDesc);
            this.setState({ loading: true });
            fetch(Config[type].url, {
                method: 'post',
                body: fromData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    ...xToken,
                }
            }).then(res => {
                if (res.ok) {
                    return res.json();
                }
            }).then(data => {
                if (data.error) {
                    message.error(data.error);
                    this.setState({ loading: false });
                } else {
                    message.success(data.success);
                    this.hide();
                    this.props.loadData();
                }
            }).catch(err => {
                message.error(err);
                this.setState({ loading: false });
            });
        }
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        const {
            customerCompanyId,
            investigationJdeContractCode,
            costType,
            serviceInvoicedAmount = 0,
            serviceExpectedPaymentAmount,
            serviceSubsequentPaymentAmount,
            ptInvoicedAmount = 0,
            ptExpectedPaymentAmount,
            ptSubsequentPaymentAmount,
        } = params;

        params[key] = value;
        switch (key) {
            case 'customerCompanyId':
                if (value) {
                    this.queryCustomerCompanyJde(value);
                    this.queryInvoicedAmountAndSignAmount(value, investigationJdeContractCode, costType);
                }
                break;
            case 'investigationJdeContractCode':
                if (value) this.queryInvoicedAmountAndSignAmount(customerCompanyId, value, costType);
                break;
            case 'costType':
                this.queryInvoicedAmountAndSignAmount(customerCompanyId, investigationJdeContractCode, value);
                break;
            case 'serviceExpectedPaymentAmount':
                if (value || value === 0) {
                    if (serviceSubsequentPaymentAmount || serviceSubsequentPaymentAmount === 0) {
                        params.serviceActualTotalAmount = Number((Number(value) + serviceSubsequentPaymentAmount + serviceInvoicedAmount).toFixed(2))
                    }
                } else {
                    params.serviceActualTotalAmount = undefined;
                }
                break;
            case 'serviceSubsequentPaymentAmount':
                if (value || value === 0) {
                    if (serviceExpectedPaymentAmount || serviceExpectedPaymentAmount === 0) {
                        params.serviceActualTotalAmount = Number((Number(value) + serviceExpectedPaymentAmount + serviceInvoicedAmount).toFixed(2))
                    }
                } else {
                    params.serviceActualTotalAmount = undefined;
                }
                break;

            case 'ptExpectedPaymentAmount':
                if (value || value === 0) {
                    if (ptSubsequentPaymentAmount || ptSubsequentPaymentAmount === 0) {
                        params.ptActualTotalAmount = Number((Number(value) + ptSubsequentPaymentAmount + ptInvoicedAmount).toFixed(2))
                    }
                } else {
                    params.ptActualTotalAmount = undefined;
                }
                break;
            case 'ptSubsequentPaymentAmount':
                if (value || value === 0) {
                    if (ptExpectedPaymentAmount || ptExpectedPaymentAmount === 0) {
                        params.ptActualTotalAmount = Number((Number(value) + ptExpectedPaymentAmount + ptInvoicedAmount).toFixed(2))
                    }
                } else {
                    params.ptActualTotalAmount = undefined;
                }
                break;
        }
        this.setState({
            params,
        }, () => {
            switch (key) {
                case 'serviceExpectedPaymentAmount':
                case 'serviceSubsequentPaymentAmount':
                    if (params.serviceActualTotalAmount || params.serviceActualTotalAmount === 0) {
                        this.queryShouldAdjustAmountAndEstimateIncomeAmount();
                    }
                    break;
                case 'ptExpectedPaymentAmount':
                case 'ptSubsequentPaymentAmount':
                    if (params.ptActualTotalAmount || params.ptActualTotalAmount === 0) {
                        this.queryShouldAdjustAmountAndEstimateIncomeAmount();
                    }
                    break;
            }
        });
    }

    beforeUpload = (file) => {
        this.setState({
            fileList: [
                ...this.state.fileList,
                file,
            ]
        })
        return false
    }

    handleRemove = (file) => {
        const { fileList } = this.state;
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        this.setState({ fileList: newFileList });
    }

    downLoadFile = (id) => {
        const url = API_URL.contract.downloadOssFile;
        ExportUtil.export({ id }, null, url);
    }

    getDataList = () => {
        const {
            params,
            type,
            fileList,
            customerCompanyList = [],
            investigationJdeContractList = [],
        } = this.state;
        const {
            applyType = [],
            applyTypeShow,
            customerCompanyId,
            customerCompanyName,
            customerConfirmFlag,
            customerConfirmFlagShow,
            investigationJdeContractCode,
            costType = [],
            costTypeShow,
            serviceInvoicedAmount,
            serviceExpectedPaymentAmount,
            serviceSubsequentPaymentAmount,
            serviceActualTotalAmount,
            serviceCtmsSignAmount,
            ptInvoicedAmount,
            ptExpectedPaymentAmount,
            ptSubsequentPaymentAmount,
            ptActualTotalAmount,
            ptCtmsSignAmount,
            shouldAdjustAmount,
            estimateIncomeAmount,
            costIncrDecr,
            adjustDesc,
            approvalStatus,
            reason,
            investigationOperationLogs = [], // 审批流程操作日志
            ossFileList = [],
        } = params;
        const showService = costType.length === 2 ? true : costType[0] === 'SERVICE_COST';
        const showPt = costType.length === 2 ? true : costType[0] === 'PT_COST';
        const isEdit = type === 'openFinance' || type === 'reOpenFinance';
        const asterisk = <span style={{ color: 'red' }}>*</span>;

        const customerCompanyOptions = customerCompanyList.map(el => <Option key={el.customerCompanyId} value={el.customerCompanyId}>{el.customerCompanyName}</Option>);

        const investigationJdeContractOptions = investigationJdeContractList.map(el => <Option key={el.investigationJdeContractId} value={el.investigationJdeContractCode}>{el.investigationJdeContractCode}</Option>);
        return (
            <div>
                {
                    type === 'approvalFinance' && <p style={{ padding: '0 30px', fontSize: '13px', fontWeight: '900' }}>审批内容：</p>
                }
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>{asterisk}申请类型：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {
                            isEdit ?
                                <CheckboxGroup
                                    value={applyType}
                                    onChange={value => this.handleChange(value, 'applyType')}
                                >
                                    <Checkbox value={"CONTRACT_AMOUNT_ADJUST"}>合同金额调整</Checkbox>
                                    <Checkbox value={"INVOICE_DATA_ADJUST"}>开票数据调整</Checkbox>
                                </CheckboxGroup>
                                : applyTypeShow
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>{asterisk}客户名称：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {
                            isEdit ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 180 }}
                                    value={customerCompanyId}
                                    onChange={value => this.handleChange(value, 'customerCompanyId')}
                                >
                                    {customerCompanyOptions}
                                </Select>
                                : customerCompanyName
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>{asterisk}有无客户确认材料：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {
                            isEdit ?
                                <RadioGroup
                                    value={customerConfirmFlag}
                                    onChange={e => this.handleChange(e.target.value, 'customerConfirmFlag')}
                                >
                                    <Radio value='YES' style={{ marginRight: 50 }}>有</Radio>
                                    <Radio value='NO'>无</Radio>
                                </RadioGroup>
                                : customerConfirmFlagShow
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>附件：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {
                            isEdit ?
                                <Upload
                                    data={{
                                        curUserId: sessionStorage.userId,
                                        curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                    }}
                                    fileList={fileList}
                                    beforeUpload={this.beforeUpload}
                                    onRemove={this.handleRemove}
                                    headers={xToken}
                                >
                                    <Button style={{ width: 80 }}>选择文件</Button>
                                </Upload>
                                :
                                ossFileList.map(el => <a onClick={() => this.downLoadFile(el.id)}>{el.fileName}<br /></a>)
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>{asterisk}JDE项目号：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {
                            isEdit ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 180 }}
                                    value={investigationJdeContractCode}
                                    onChange={value => this.handleChange(value, 'investigationJdeContractCode')}
                                >
                                    {investigationJdeContractOptions}
                                </Select>
                                : investigationJdeContractCode
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>{asterisk}申请开票费用类型：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {
                            isEdit ?
                                <CheckboxGroup
                                    value={costType}
                                    onChange={value => this.handleChange(value, 'costType')}
                                >
                                    <Checkbox value={"SERVICE_COST"}>服务费</Checkbox>
                                    <Checkbox value={"PT_COST"}>PT费</Checkbox>
                                </CheckboxGroup>
                                : costTypeShow
                        }
                    </div>
                </li>
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>已开票金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', serviceInvoicedAmount)}
                        </div>
                    </li>
                }
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>预计本次请款金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {
                                isEdit ?
                                    <InputNumber
                                        style={{ width: 180 }}
                                        placeholder='请输入'
                                        step={0.01}
                                        value={serviceExpectedPaymentAmount}
                                        min={0}
                                        precision={2}
                                        onChange={value => this.handleChange(value, 'serviceExpectedPaymentAmount')}
                                    />
                                    : format('money', serviceExpectedPaymentAmount)
                            }
                        </div>
                    </li>
                }
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>后期还待请款金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {
                                isEdit ?
                                    <InputNumber
                                        style={{ width: 180 }}
                                        placeholder='请输入'
                                        step={0.01}
                                        value={serviceSubsequentPaymentAmount}
                                        min={0}
                                        precision={2}
                                        onChange={value => this.handleChange(value, 'serviceSubsequentPaymentAmount')}
                                    />
                                    : format('money', serviceSubsequentPaymentAmount)
                            }
                        </div>
                    </li>
                }
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>实际总金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', serviceActualTotalAmount)}
                        </div>
                    </li>
                }
                {
                    showService &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>CTMS登记签署金额（服务费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', serviceCtmsSignAmount)}
                        </div>
                    </li>
                }

                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>已开票金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', ptInvoicedAmount)}
                        </div>
                    </li>
                }
                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>预计本次请款金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {
                                isEdit ?
                                    <InputNumber
                                        style={{ width: 180 }}
                                        step={0.01}
                                        placeholder='请输入'
                                        value={ptExpectedPaymentAmount}
                                        min={0}
                                        precision={2}
                                        onChange={value => this.handleChange(value, 'ptExpectedPaymentAmount')}
                                    />
                                    : format('money', ptExpectedPaymentAmount)
                            }
                        </div>
                    </li>
                }
                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>后期还待请款金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {
                                isEdit ?
                                    <InputNumber
                                        style={{ width: 180 }}
                                        step={0.01}
                                        placeholder='请输入'
                                        value={ptSubsequentPaymentAmount}
                                        min={0}
                                        precision={2}
                                        onChange={value => this.handleChange(value, 'ptSubsequentPaymentAmount')}
                                    />
                                    : format('money', ptSubsequentPaymentAmount)
                            }
                        </div>
                    </li>
                }
                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>实际总金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', ptActualTotalAmount)}
                        </div>
                    </li>
                }
                {
                    showPt &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>CTMS登记签署金额（PT费）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', ptCtmsSignAmount)}
                        </div>
                    </li>
                }
                {
                    (showService || showPt) &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>本次应调整金额：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {format('money', shouldAdjustAmount)}
                        </div>
                    </li>
                }
                {
                    (showService || showPt) &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>{asterisk}预估收入影响金额（仅影响审批流）：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {
                                isEdit ?
                                    <InputNumber
                                        style={{ width: 180 }}
                                        step={0.01}
                                        placeholder='请输入'
                                        value={estimateIncomeAmount}
                                        min={0}
                                        precision={2}
                                        onChange={value => this.handleChange(value, 'estimateIncomeAmount')}
                                    />
                                    : format('money', estimateIncomeAmount)
                            }
                        </div>
                    </li>
                }
                {
                    (showService || showPt) &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>费用增减：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            {costIncrDecr}
                        </div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>请填写此次开启财务数据调整备注：</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {
                            isEdit ?
                                <TextArea
                                    style={{ width: 180 }}
                                    placeholder='请输入'
                                    rows={4}
                                    value={adjustDesc}
                                    onChange={e => this.handleChange(e.target.value, 'adjustDesc')}
                                />
                                : adjustDesc
                        }
                    </div>
                </li>
                {
                    type === 'approvalFinance' &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>{asterisk}审批结论：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            <RadioGroup
                                value={approvalStatus}
                                onChange={e => this.handleChange(e.target.value, 'approvalStatus')}
                            >
                                <Radio value='APPROVE_PASS' style={{ marginRight: 50 }}>审批通过</Radio>
                                <Radio value='APPROVE_NOT_PASS'>审批不通过</Radio>
                            </RadioGroup>
                        </div>
                    </li>
                }
                {
                    approvalStatus === 'APPROVE_NOT_PASS' &&
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '45%' }}>{asterisk}不通过原因：</div>
                        <div className="item-right" style={{ width: '55%' }}>
                            <Input
                                style={{ width: 180 }}
                                placeholder='请输入'
                                value={reason}
                                onChange={e => this.handleChange(e.target.value, 'reason')}
                            />
                        </div>
                    </li>
                }
                {
                    type === 'approvalFinance' && <div style={{ position: 'relative', marginTop: 8, borderTop: '1px solid #e4e4e4' }} />
                }
                {
                    type === 'approvalFinance' && <div>
                        <p style={{ padding: '10px 30px', fontSize: '13px', fontWeight: '900' }}>审批流程意见：</p>
                        <Table
                            dataSource={investigationOperationLogs}
                            bordered
                            columns={this.getColumns()}
                            pagination={false}
                        />
                    </div>
                }
            </div>
        )
    }

    getColumns = () => {
        const columns = [{
            title: '操作时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 100,
        }, {
            title: '操作人员',
            dataIndex: 'createUserName',
            key: 'createUserName',
            width: 100,
        }, {
            title: '接收人',
            dataIndex: 'receiveUser',
            key: 'receiveUser',
            width: 100,
        }, {
            title: '操作说明',
            dataIndex: 'operationContentShow',
            key: 'operationContentShow',
            width: 100,
        }];
        return columns
    }

    render() {
        const { visible, loading, type } = this.state;
        return (
            <Modal
                title={Config[type].title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="700px"
                footer={type === 'view' ?
                    <Button key="cancel" onClick={this.hide}>关闭</Button> :
                    [
                        <Button key="cancel" onClick={this.hide}>取消</Button>,
                        <Button key="ok" type="primary" onClick={this.submit} loading={loading}>确定</Button>,
                    ]
                }
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        <ul className="modal-list">
                            {this.getDataList()}
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )
    }
}

export default FinanceAdjust;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/FinanceAdjust.js